import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

export default function Badge({
  className,
  children,
  ...props
}: ComponentProps<"span">) {
  return (
    <span
      className={twMerge(
        "inline-block text-xs text-[#9A9EB1] font-normal border border-[#ECEFF2] rounded py-1 px-2",
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
}
